<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" style="margin-bottom:0em;"><a id="pxiii">E<span class="small">PHESIANS</span> 5:22- 33</a></p><a id="pxiii">
<p class="centerhead">(The Message)</p>
<p class="noindent"><b>Wives, understand and support</b> your husbands in ways that show your support for Christ. The husband provides leadership to his wife the way Christ does to His Church, not by domineering but by cherishing. So just as the Church submits to Christ as He exercises such leadership, wives should likewise submit to their husbands.</p>
</a><p class="indent"><a id="pxiii">Husbands, go all out in your love for your wives, exactly as Christ did for the Church- a love marked by giving, not getting. Christ’s love makes the Church whole. His words evoke her beauty. Everything He does </a><a id="pxiv">and says is designed to bring the best out of her, dressing her in dazzling white silk, radiant with holiness. And that is how husbands ought to love their wives. They’re really doing themselves a favor- since they’re already “one” in marriage.</a></p><a id="pxiv">
<p class="indent">No one abuses his own body, does he? No, he feeds and pampers it. That’s how Christ treats us, the Church, since we are part of His body. And this is why a man leaves father and mother and cherishes his wife. No longer two, they become “one flesh.” This is a huge mystery, and I don’t pretend to understand it all. What is clearest to me is the way Christ treats the Church. And this provides a good picture of how each husband is to treat his wife, loving himself in loving her, and how each wife is to honor her husband.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ephesians.vue?79f147f3